<mat-card class="addUserCard">
    <mat-card-header mat-dialog-title>
        <mat-card-title class="text-uppercase text-left model-header addUser-modal-header">Add User</mat-card-title>
        <div class="dialog-close">
            <button mat-button matSuffix mat-icon-button [mat-dialog-close]="true">
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </mat-card-header>
</mat-card>
<mat-card-content>
    <form (ngSubmit)="onSubmit()" [formGroup]="FormHelper?.addUserForm">
        <div class="d-flex mx-auto w-100 addUserForm">
            <div class="col-9 addUserLeft">
                <h4>User Details</h4>

                <mat-form-field class="col-11">
                    <span class="astrick">*</span>
                    <mat-label>Username:</mat-label>
                    <input matInput type="text" id="username" class="form-control" formControlName="username"
                           cdkfocusinitial>
                </mat-form-field>

                <mat-form-field class="col-11">
                    <span class="astrick">*</span>
                    <mat-label>Password:</mat-label>
                    <input matInput id="password" class="form-control" formControlName="password" required
                           type="password">
                </mat-form-field>

                <mat-form-field class="col-11">
                    <mat-label>First Name:</mat-label>
                    <span class="astrick">*</span>
                    <input matInput type="text" id="firstname" class="form-control" formControlName="firstname">
                </mat-form-field>

                <mat-form-field class="col-11">
                    <mat-label>Last Name:</mat-label>
                    <span class="astrick">*</span>
                    <input matInput type="text" id="lastname" class="form-control" formControlName="lastname">
                </mat-form-field>

                <mat-form-field class="col-11">
                    <mat-label>Title:</mat-label>
                    <input matInput type="text" id="title" class="form-control" formControlName="title">
                </mat-form-field>

                <mat-form-field class="col-11">
                    <mat-label>Email:</mat-label>
                    <span class="astrick">*</span>
                    <input matInput id="emailAddress" class="form-control" formControlName="emailAddress" type="email">
                </mat-form-field>

                <mat-form-field class="col-11">
                    <mat-label>Phone Number:</mat-label>
                    <span class="astrick">*</span>
                    <input matInput type="text" id="phonenumber" class="form-control" formControlName="phonenumber">
                </mat-form-field>

            </div>
            <div class="col-3 addUserRight">
                <h4>Roles</h4>
                <mat-radio-group required formControlName="role">
                    <div *ngFor="let role of roles">
                        <mat-radio-button [value]="role.value">{{role.label}}</mat-radio-button>
                        <br>
                    </div>
                </mat-radio-group>
            </div>
        </div>

        <div class="col text-right">
            <button class="submit" mat-raised-button [color]="'primary'" [disabled]="FormHelper.addUserForm.invalid"
                    (click)="onSubmit()" mat-dialog-close>Save
            </button>
            <button mat-raised-button [mat-dialog-close]="true">Close</button>
        </div>
    </form>
</mat-card-content>
